
import { Record, Union } from "../../fable_modules/fable-library-js.5.0.0/Types.js";
import { record_type, bool_type, int32_type, list_type, string_type, union_type } from "../../fable_modules/fable-library-js.5.0.0/Reflection.js";
import { exists, filter, singleton as singleton_2, map as map_1, ofArray, tryHead, length, sumBy } from "../../fable_modules/fable-library-js.5.0.0/List.js";
import { max } from "../../fable_modules/fable-library-js.5.0.0/Double.js";
import { value as value_18, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0/Option.js";
import { split, interpolate } from "../../fable_modules/fable-library-js.5.0.0/String.js";
import { Fragment, useMemo, createElement, useState } from "react";
import React from "react";
import { int32ToString, comparePrimitives, equals } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { WeatherValue_valuesNotEmpty, ViewHelpers_spanWith, ViewHelpers_mkColumnWith, ViewHelpers_spaceN, ViewHelpers_mkColumn, ViewHelpers_divWith, ViewHelpers_mkTextSizeUnit, ViewHelpers_mkRow } from "./PortWindCommon.js";
import { Color, theme } from "../../Theme.js";
import { ModalModule_view } from "../../Components/StenaWebUI/Modal/Modal.js";
import { ofList } from "../../fable_modules/fable-library-js.5.0.0/Map.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0/Seq.js";
import { ButtonBase_ViewSecondary, ButtonBase_ViewPrimary } from "../../Components/StenaWebUI/Elements/Button.js";
import { awaitPromise, startImmediate } from "../../fable_modules/fable-library-js.5.0.0/Async.js";
import { singleton as singleton_1 } from "../../fable_modules/fable-library-js.5.0.0/AsyncBuilder.js";
import { toString } from "../../fable_modules/fable-library-js.5.0.0/Date.js";
import { op_Subtraction, addHours, utcNow } from "../../fable_modules/fable-library-js.5.0.0/DateOffset.js";
import { buildCsvContent } from "./PortWindTable.js";
import { Request_ExportCsvRequest__ToUrl, Request_ExportCsvRequest } from "../../StenaWeather.WeatherServiceUI.Shared/PortWind/API.js";
import { Auth_userManager } from "../../Server.js";
import { totalHours as totalHours_1 } from "../../fable_modules/fable-library-js.5.0.0/TimeSpan.js";
import { IconModule_View } from "../../Components/StenaWebUI/Icons/Icon.js";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0/Util.js";
import { SensorId } from "../../StenaWeather.Domain/PortWind.js";
import { downloadCsv } from "../../Utils.js";
import { contains } from "../../fable_modules/fable-library-js.5.0.0/Set.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.5.0.0/Util.js";

export class DownloadMode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Averaged", "AllData"];
    }
}

export function DownloadMode_$reflection() {
    return union_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindExport.DownloadMode", [], DownloadMode, () => [[], []]);
}

export class CsvExportInfo extends Record {
    constructor(Filename, Rows, NumDataRows, NumCols, IsMeanValues, EstimatedSizeBytes, AllDataEstimatedRows, AllDataEstimatedSizeBytes) {
        super();
        this.Filename = Filename;
        this.Rows = Rows;
        this.NumDataRows = (NumDataRows | 0);
        this.NumCols = (NumCols | 0);
        this.IsMeanValues = IsMeanValues;
        this.EstimatedSizeBytes = (EstimatedSizeBytes | 0);
        this.AllDataEstimatedRows = (AllDataEstimatedRows | 0);
        this.AllDataEstimatedSizeBytes = (AllDataEstimatedSizeBytes | 0);
    }
}

export function CsvExportInfo_$reflection() {
    return record_type("StenaWeather.WeatherServiceUI.Client.Pages.Portwind.PortWindExport.CsvExportInfo", [], CsvExportInfo, () => [["Filename", string_type], ["Rows", list_type(list_type(string_type))], ["NumDataRows", int32_type], ["NumCols", int32_type], ["IsMeanValues", bool_type], ["EstimatedSizeBytes", int32_type], ["AllDataEstimatedRows", int32_type], ["AllDataEstimatedSizeBytes", int32_type]]);
}

export function CsvExportInfoModule_ofRows(filename, isMeanValues, allDataEstimatedRows, allDataEstimatedSizeBytes, rows) {
    const estimatedSizeBytes = (sumBy((row) => ((sumBy((s) => (s.length | 0), row, {
        GetZero: () => 0,
        Add: (x, y) => ((x + y) | 0),
    }) + max(0, length(row) - 1)) | 0), rows, {
        GetZero: () => 0,
        Add: (x_1, y_1) => ((x_1 + y_1) | 0),
    }) + max(0, length(rows) - 1)) | 0;
    return new CsvExportInfo(filename, rows, length(rows) - 1, defaultArg(map((list_3) => (length(list_3) | 0), tryHead(rows)), 0), isMeanValues, estimatedSizeBytes, allDataEstimatedRows, allDataEstimatedSizeBytes);
}

function formatSize(bytes) {
    if (bytes < 1024) {
        return `${bytes} B`;
    }
    else if (bytes < (1024 * 1024)) {
        return `${interpolate("%.1f%P()", [bytes / 1024])} KB`;
    }
    else {
        return `${interpolate("%.1f%P()", [bytes / (1024 * 1024)])} MB`;
    }
}

export function csvExportModalView($props) {
    const info = $props.info;
    const onConfirm = $props.onConfirm;
    const onClose = $props.onClose;
    const isOpen = $props.isOpen;
    const patternInput = useState(new DownloadMode(0, []));
    const setMode = patternInput[1];
    const mode = patternInput[0];
    const patternInput_1 = useState(false);
    const setIsDownloading = patternInput_1[1];
    const isDownloading = patternInput_1[0];
    const isAveraged = equals(mode, new DownloadMode(0, []));
    const isAllData = equals(mode, new DownloadMode(1, []));
    const infoRow = (label, value) => ViewHelpers_mkRow(ofArray([ViewHelpers_mkTextSizeUnit(theme(new Color(0, [])), 14 + "px", [["fontWeight", "bold"], ["width", 160 + "px"]], label), ViewHelpers_mkTextSizeUnit(theme(new Color(0, [])), 14 + "px", [], value)]));
    const patternInput_2 = (mode.tag === 1) ? [info.IsMeanValues ? (info.NumCols - 1) : info.NumCols, info.AllDataEstimatedRows, info.AllDataEstimatedSizeBytes] : [info.NumCols, info.NumDataRows, info.EstimatedSizeBytes];
    return ModalModule_view(ofList(map_1((value_17) => value_17, ofArray([["isOpen", isOpen], ["headerText", "Export CSV"], ["width", "25vw"], ["onRequestClose", onClose], ["children", singleton_2(ViewHelpers_divWith([["style", {
        padding: 20 + "px",
    }]], singleton_2(ViewHelpers_mkColumn(toList(delay(() => append(info.IsMeanValues ? append(singleton(ViewHelpers_mkRow(toList(delay(() => append(singleton((isAveraged ? ((props) => {
        const p_1_1 = ofList(map_1((value_11) => value_11, props), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        });
        return createElement(ButtonBase_ViewPrimary, {
            p: p_1_1,
        });
    }) : ((props_2) => ButtonBase_ViewSecondary(ofList(map_1((value_12) => value_12, props_2), {
        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
    }))))(ofArray([["label", "Averaged"], ["onClick", (_arg) => {
        if (!isDownloading) {
            setMode(new DownloadMode(0, []));
        }
    }]]))), delay(() => append(ViewHelpers_spaceN(1), delay(() => singleton((isAllData ? ((props_4) => {
        const p_1_3 = ofList(map_1((value_13) => value_13, props_4), {
            Compare: (x_2, y_2) => (comparePrimitives(x_2, y_2) | 0),
        });
        return createElement(ButtonBase_ViewPrimary, {
            p: p_1_3,
        });
    }) : ((props_6) => ButtonBase_ViewSecondary(ofList(map_1((value_14) => value_14, props_6), {
        Compare: (x_3, y_3) => (comparePrimitives(x_3, y_3) | 0),
    }))))(ofArray([["label", "All data"], ["onClick", (_arg_1) => {
        if (!isDownloading) {
            setMode(new DownloadMode(1, []));
        }
    }]]))))))))))), delay(() => ViewHelpers_spaceN(2))) : empty(), delay(() => append(singleton(infoRow("Rows:", `~${patternInput_2[1]} (estimated)`)), delay(() => append(ViewHelpers_spaceN(1), delay(() => append(singleton(infoRow("Columns:", int32ToString(patternInput_2[0]))), delay(() => append(ViewHelpers_spaceN(1), delay(() => append(info.IsMeanValues ? append(singleton(infoRow("Averaged data:", isAveraged ? "Yes" : "No")), delay(() => ViewHelpers_spaceN(1))) : empty(), delay(() => append(singleton(infoRow("Estimated size:", formatSize(patternInput_2[2]))), delay(() => append(ViewHelpers_spaceN(3), delay(() => {
        let p_1_6;
        return singleton(ViewHelpers_mkRow(singleton_2(ViewHelpers_mkColumnWith([["justifyContent", "flex-end"]], singleton_2(ViewHelpers_mkRow(ofArray([ButtonBase_ViewSecondary(ofList(map_1((value_15) => value_15, ofArray([["label", "Cancel"], ["onClick", (_arg_2) => {
            if (!isDownloading) {
                onClose();
            }
        }]])), {
            Compare: (x_4, y_4) => (comparePrimitives(x_4, y_4) | 0),
        })), (p_1_6 = ofList(map_1((value_16) => value_16, toList(delay(() => append(singleton(["label", "Download"]), delay(() => append(isDownloading ? singleton(["loading", true]) : empty(), delay(() => append(isDownloading ? singleton(["loadingLabel", "Downloading..."]) : empty(), delay(() => singleton(["onClick", (_arg_3) => {
            if (!isDownloading) {
                setIsDownloading(true);
                startImmediate(singleton_1.Delay(() => singleton_1.TryFinally(singleton_1.Delay(() => singleton_1.Bind(onConfirm(mode), () => singleton_1.Return(undefined))), () => {
                    setIsDownloading(false);
                    onClose();
                })));
            }
        }])))))))))), {
            Compare: (x_5, y_5) => (comparePrimitives(x_5, y_5) | 0),
        }), createElement(ButtonBase_ViewPrimary, {
            p: p_1_6,
        }))])))))));
    }))))))))))))))))))))))]])), {
        Compare: (x_6, y_6) => (comparePrimitives(x_6, y_6) | 0),
    }));
}

export function openCsvExportModal(state, ctx, setCsvExport, expandedValues, unitVar) {
    const chartsValues = filter((values) => exists((d) => exists((w) => (d.GetValue(state, w) != null), state.WeatherHistory), values), map_1(singleton_2, expandedValues));
    const sensorPart = defaultArg(map((_arg) => _arg.fields[0], state.SelectedSensor), "data");
    const datePart = toString(utcNow(), "yyyy-MM-dd");
    const patternInput = buildCsvContent(chartsValues, ctx, state);
    const rows = patternInput[1];
    const isMeanValues = patternInput[0];
    startImmediate(singleton_1.Delay(() => singleton_1.Bind((isMeanValues && (state.SelectedSensor != null)) ? singleton_1.Delay(() => {
        const now = utcNow();
        const patternInput_1 = state.DateTimeRange;
        const endDate = defaultArg(patternInput_1.fields[1], now);
        const sampleStart = addHours(endDate, -1);
        const sampleReq = new Request_ExportCsvRequest(value_18(state.SelectedSensor), sampleStart, endDate, "");
        return singleton_1.Bind(awaitPromise(Auth_userManager.getUser()), (_arg_1) => {
            const token = defaultArg(map((u) => u.access_token, _arg_1), "");
            return singleton_1.Bind(singleton_1.Delay(() => singleton_1.TryWith(singleton_1.Delay(() => singleton_1.ReturnFrom(awaitPromise(fetch(Request_ExportCsvRequest__ToUrl(sampleReq), { headers: { Authorization: 'Bearer ' + token } }).then(r => { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })))), (_arg_2) => singleton_1.Return(""))), (_arg_3) => {
                let array_1, array;
                const sampleCsv = _arg_3;
                const sampleRows = max(0, -1 + ((array_1 = ((array = split(sampleCsv, ["\n"], undefined, 0), array.filter((s_1) => (s_1.trim() !== "")))), array_1.length))) | 0;
                if (sampleRows === 0) {
                    return singleton_1.Return([max(0, length(rows) - 1), 0]);
                }
                else {
                    const sampleBytes = (new TextEncoder().encode(sampleCsv).length) | 0;
                    const totalHours = totalHours_1(op_Subtraction(endDate, defaultArg(patternInput_1.fields[0], addHours(now, -4))));
                    return singleton_1.Return([~~(sampleRows * totalHours), ~~(sampleBytes * totalHours)]);
                }
            });
        });
    }) : singleton_1.Delay(() => singleton_1.Return([max(0, length(rows) - 1), 0])), (_arg_4) => {
        setCsvExport(CsvExportInfoModule_ofRows(`portwind_${sensorPart}_${datePart}.csv`, isMeanValues, _arg_4[0], _arg_4[1], rows));
        return singleton_1.Zero();
    })));
}

export function csvDownloadIcon(state, ctx, setCsvExport, expandedValues, unitVar) {
    let t;
    return ViewHelpers_spanWith([["onClick", (_arg) => {
        openCsvExportModal(state, ctx, setCsvExport, expandedValues, undefined);
    }], ["style", {
        alignSelf: "center",
        cursor: "pointer",
    }]], singleton_2(IconModule_View(ofList(map_1((value_5) => value_5, ofArray([(t = faDownload, ["icon", t]), ["color", theme(new Color(5, []))], ["size", 4 + "vmin"]])), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    }))));
}

export function csvExportModal(state, setCsvExport, csvExport) {
    if (csvExport == null) {
        return defaultOf();
    }
    else {
        const info = csvExport;
        return createElement(csvExportModalView, {
            isOpen: true,
            onClose: () => {
                setCsvExport(undefined);
            },
            onConfirm: (mode) => {
                if (mode.tag === 1) {
                    const now = utcNow();
                    const patternInput = state.DateTimeRange;
                    const req = new Request_ExportCsvRequest(defaultArg(state.SelectedSensor, new SensorId("")), defaultArg(patternInput.fields[0], addHours(now, -4)), defaultArg(patternInput.fields[1], now), info.Filename);
                    return singleton_1.Delay(() => singleton_1.Bind(awaitPromise(Auth_userManager.getUser()), (_arg) => {
                        const token = defaultArg(map((u) => u.access_token, _arg), "");
                        return singleton_1.Bind(awaitPromise(fetch(Request_ExportCsvRequest__ToUrl(req), { headers: { Authorization: 'Bearer ' + token } }).then(r => {
    if (!r.ok) throw new Error('HTTP ' + r.status);
    return r.blob();
}).then(blob => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = info.Filename; a.click();
    URL.revokeObjectURL(url);
})), () => singleton_1.Return(undefined));
                    }));
                }
                else {
                    downloadCsv(info.Filename, info.Rows);
                    return singleton_1.Return(undefined);
                }
            },
            info: info,
        });
    }
}

/**
 * Self-contained download button + modal. Owns its own csvExport state so that
 * opening/closing the modal does NOT re-render the parent dashboard (and chart).
 */
export function csvExportSection($props) {
    const expandForGroupSensor = $props.expandForGroupSensor;
    const ctx = $props.ctx;
    const state = $props.state;
    const patternInput = useState(undefined);
    const setCsvExport = patternInput[1];
    const xs = [csvDownloadIcon(state, ctx, setCsvExport, useMemo(() => expandForGroupSensor(filter((x) => !contains(x.Id, state.HiddenWeatherValues), WeatherValue_valuesNotEmpty(state))), [state.WeatherHistory, state.HiddenWeatherValues, state.HiddenSensors]), undefined), csvExportModal(state, setCsvExport, patternInput[0])];
    return createElement(Fragment, defaultOf_1(), ...xs);
}

